import { useNavigate } from "react-router-dom"

import { Flex, Tabs } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import { HeaderPage } from "@/organisms/HeaderPage"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"
import { PageTemplate } from "@/templates/PageTemplate"
import { TabsTemplate } from "@/templates/TabsTemplate"
import { AiPoliciesTab } from "./components/AiPoliciesTab"
import { CreateAiPolicyButton } from "./components/CreateAiPolicyButton"
import { DecisionsTab } from "./components/DecisionsTab"
import { AI_POLICIES_TABS, getDecisionsUrl } from "./const"

import styles from "./AiPoliciesPage.module.scss"

import type { AiPoliciesPageProps } from "./AiPoliciesPage.types"

export const AiPoliciesPage = ({ tab }: AiPoliciesPageProps) => {
  const navigate = useNavigate()
  const { live, source } = useAiPolicies()
  const { t } = useTranslation("translation", { keyPrefix: "governance.ai" })
  const { ROOT, AI } = NAMES_ROUTES.GOVERNANCE
  const policiesUrl = `/${ROOT}/${AI}`

  return (
    <PageTemplate
      full
      header={<HeaderPage titleTranslationKey="AI Policies" />}
    >
      <Flex vertical gap={16}>
        <span />
        <Flex align="center" justify="space-between">
          <Heading title="AI Policies" level={5} />
          <CreateAiPolicyButton
            withKinds={source === "live"}
            disabled={live?.canWrite === false}
          />
        </Flex>
        <TabsTemplate>
          <Tabs
            destroyOnHidden
            activeKey={tab}
            onChange={(key) =>
              navigate(
                key === AI_POLICIES_TABS.DECISIONS
                  ? getDecisionsUrl()
                  : policiesUrl
              )
            }
            items={[
              {
                key: AI_POLICIES_TABS.POLICIES,
                label: t("tabs.policies"),
                children: (
                  <Flex className={styles.wrapper}>
                    <AiPoliciesTab />
                  </Flex>
                )
              },
              {
                key: AI_POLICIES_TABS.DECISIONS,
                label: t("tabs.decisions"),
                children: <DecisionsTab />
              }
            ]}
          />
        </TabsTemplate>
      </Flex>
    </PageTemplate>
  )
}
